import React from "react";
import ElectedExecutive from "../../assets/images/elected.jpg";
import AppointedExecutives from "../../assets/images/appointed.jpg";

const ElectedExecutives = () => {
  return (
    <section className="min-h-screen  flex flex-col">
      <h2 className="text-3xl font-bold text-center text-gray-800 pt-8 pb-4">
        Know Your Executives
      </h2>
      <div className="flex-1 flex flex-col md:flex-row gap-6 px-4 md:px-12 lg:px-20">
        {/* Elected Executives */}
        <div className="flex-1 flex flex-col items-center p-4">
          <h3 className="text-2xl font-semibold text-center text-gray-700 mb-4">
            Core Executives
          </h3>
          <div className="w-[120%] sm:w-[90%] md:w-full md:max-w-2xl lg:max-w-3xl xl:max-w-4xl min-h-[300px] md:min-h-[400px] lg:min-h-[500px] bg-white rounded-sm shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden">
            <img
              src={ElectedExecutive}
              alt="Elected Executive"
              className="w-full h-full object-cover transform transition-transform duration-700 hover:scale-105"
            />
          </div>
        </div>
        
        {/* Appointed Executives */}
        <div className="flex-1 flex flex-col items-center p-4">
          <h3 className="text-2xl font-semibold text-center text-gray-700 mb-4">
            Appointed Executive
          </h3>
          <div className="w-[120%] sm:w-[90%] md:w-full md:max-w-2xl lg:max-w-3xl xl:max-w-4xl min-h-[300px] md:min-h-[400px] lg:min-h-[500px] bg-white rounded-sm shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden">
            <img
              src={AppointedExecutives}
              alt="Appointed Executive"
              className="w-full h-full object-cover transform transition-transform duration-700 hover:scale-105"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ElectedExecutives;